<template>
  <div class="kv" v-if="isShow.isKVShow">
    <div class="kv-title-wp">
      <div class="kv-title1"></div>
      <div class="kv-title2"></div>
    </div>
    <div class="kv-desk-wp">
      <div class="kv-desk-rank"></div>
      <div class="kv-desk-start scaleIt" @click="showNext"></div>
      <div class="kv-desk-store"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loading',
  props: {
    isShow: Object
  },
  methods: {
    showNext() {
      this.$emit('nextPage', 'isPOShow')
    }
  }
}
</script>

<style lang="less" scoped>
/* 首页 */
.bg(@url) {
  background-image: url(@url);
  background-size: cover;
  background-repeat: no-repeat;
}
.kv {
  width: 100vw;
  height: 100vh;
  .bg('./img/kv-bg.jpg');
}
.kv-title-wp {
  position: absolute;
  width: 100vw;
  top: 8vh;
}
.kv-title2 {
  position: absolute;
  top: 1.875rem;
  left: 50%;
  margin-left: -39.4375/4rem /* 631/16 */;
  width: 39.4375/2rem /* 631/16 */;
  height: 26.3125/2rem /* 421/16 */;
  .bg('./img/kv-title1.png');
}
.kv-title1 {
  position: absolute;
  margin-left: -6.6rem;
  left: 50%;
  width: 24.875/2rem /* 398/16 */;
  height: 5.5625/2rem /* 89/16 */;
  .bg('./img/kv-title2.png');
}
.kv-desk-wp {
  position: absolute;
  bottom: 6vh;
  width: 46.875/2rem /* 750/16 */;
  height: 35.9375/2rem /* 575/16 */;
  .bg('./img/kv-desk.png');
}
.kv-desk-rank {
  position: absolute;
  top: -1rem;
  width: 12.5625/2rem /* 201/16 */;
  height: 10.9375/2rem /* 175/16 */;
  background-image: url('./img/kv-rank.png');
  background-size: cover;
  background-repeat: no-repeat;
}
.kv-desk-start {
  position: absolute;
  left: 50%;
  top: -.5rem;
  margin-left: -19.6875/4rem /* 315/16 */;
  width: 19.6875/2rem /* 315/16 */;
  height: 13/2rem /* 208/16 */;
  background-image: url('./img/kv-start.png');
  background-size: cover;
  background-repeat: no-repeat;
}
.kv-desk-store {
  position: absolute;
  top: -1.5rem;
  right: 1rem;
  width: 10.125/2rem /* 162/16 */;
  height: 8.8125/2rem /* 141/16 */;
  background-image: url('./img/kv-store.png');
  background-size: cover;
  background-repeat: no-repeat;
}
.scaleIt {
  animation: scaleIt 1s ease-in-out infinite both;
}
@keyframes scaleIt {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}
</style>